import { Link } from "react-router-dom";
import "./index.css";

export default function ContactModal({ triggerClass = "btn-outline" }) {
    // const [isOpen, setIsOpen] = useState(false);

    // const openModal = () => setIsOpen(true);
    // const closeModal = () => setIsOpen(false);

    return (
        <>
            {/* Contact Sales button */}
            <Link to="/sales" style={{ textDecoration: "none" }}>
                <div className={triggerClass}>
                    Contact Us
                </div>
            </Link>


            {/* Modal
            {isOpen && (
                <div className="contactForm-overlay" onClick={closeModal}>
                    <div className="contactForm-content" onClick={(e) => e.stopPropagation()}>
                        <button className="contactForm-close-btn" onClick={closeModal}>
                            &times;
                        </button>
                        <ContactForm triggerClass={triggerClass}/>
                    </div>
                </div>
            )} */}
        </>
    );
}
